import { useContext, createContext } from 'react';

const FriendsContext = createContext();
FriendsContext.displayName = 'FriendsContext';

export const useFriendsContext = () => {
  const context = useContext(FriendsContext);

  if (!context) {
    throw new Error(
      'useFriendsContext must be used within the FriendsContext.Provider'
    );
  }

  return context;
};

export default FriendsContext;
